__turbopack_context__.v({
  "className": "esklarheitgrotesk_ddd1a9d0-module__m_N8Oa__className",
  "variable": "esklarheitgrotesk_ddd1a9d0-module__m_N8Oa__variable",
});
